<template>
  <div class="my-table">
    <template v-if="tableData.data.length > 0">
      <div class="tableTitle">
        <div
          :class="[
            item == '账号状态'
              ? 'titleItem status'
              : item == '角色'
              ? 'titleItem type'
              : item == '描述'
              ? 'titleItem description'
              : 'titleItem',
          ]"
          v-for="(item, index) in tableData.titleList"
          :key="index"
        >
          {{ item }}
        </div>
        <div class="titleItem action">操作</div>
      </div>
      <div class="tableBody" v-if="typeList.length != 0">
        <div
          :class="[index % 2 ? 'bodyItem bodyItem1' : 'bodyItem']"
          v-for="(item, index) in tableData.data"
          :key="index"
        >
          <div
            v-for="i in tableData.dataList"
            :key="i"
            :class="[
              i == 'status'
                ? 'status'
                : i == 'roles'
                ? 'type'
                : i == 'description'
                ? 'description'
                : '',
            ]"
          >
            <!-- <i-switch
              v-if="i == 'status'"
              v-model="item[i]"
              disabled="false"
              style="opacity: 1"
            ></i-switch> -->
            <span
              v-if="i == 'status'"
              :class="[item[i] == 0 ? 'status status0' : 'status status1']"
              >{{ item[i] == 0 ? "正常" : "停用" }}</span
            >
            <!-- <span v-else-if="i == 'roleIds'">{{
              typeList[item[i]].title
            }}</span> -->
            <span v-else-if="i == 'roles'">
              <span v-for="e in item[i]" :key="e.id">{{ e.name }}</span>
            </span>
            <span
              v-else
              :class="[i == 'username' || i == 'departmentTitle' ? 'blue' : '']"
              >{{ item[i] }}</span
            >
          </div>
          <div class="action action1">
            <div
              class="actionItem"
              @mouseenter="buttonEnter(index, 'game')"
              @mouseleave="buttonLeave"
              @click="tableGame(item)"
              v-if="tableData.action.game"
            >
              <div class="icon icon1"></div>
              <div class="tipBox" v-show="inNum == index && inButton == 'game'">
                <span class="tipText">游戏设置</span>
                <div class="arrow"></div>
              </div>
            </div>
            <div
              class="actionItem"
              @mouseenter="buttonEnter(index, 'manager')"
              @mouseleave="buttonLeave"
              @click="tableManager(item)"
              v-if="tableData.action.manager"
            >
              <div class="icon icon2"></div>
              <div
                class="tipBox"
                v-show="inNum == index && inButton == 'manager'"
              >
                <span class="tipText">管理员设置</span>
                <div class="arrow"></div>
              </div>
            </div>
            <div
              class="actionItem"
              @mouseenter="buttonEnter(index, 'write')"
              @mouseleave="buttonLeave"
              @click="tableWrite(item)"
              v-if="tableData.action.write"
            >
              <div class="icon icon3"></div>
              <div
                class="tipBox"
                v-show="inNum == index && inButton == 'write'"
              >
                <span class="tipText">编辑</span>
                <div class="arrow"></div>
              </div>
            </div>
            <div
              class="actionItem"
              @mouseenter="buttonEnter(index, 'del')"
              @mouseleave="buttonLeave"
              @click="tableDel(item)"
              v-if="tableData.action.del"
            >
              <div class="icon icon4"></div>
              <div class="tipBox" v-show="inNum == index && inButton == 'del'">
                <span class="tipText">删除</span>
                <div class="arrow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Page
        :total="tableData.total"
        show-elevator
        class-name="pageChoose"
        :current="pageForm.current"
        @on-change="pageChange"
        v-if="tableData.pageChange"
      ></Page>
    </template>
    <template v-else>
      <div style="text-align: center">暂无数据~</div>
    </template>
  </div>
</template>

<script>
import { getDictDataByType } from "@/api/index";
export default {
  name: "my-table",
  props: ["tableData"],
  data() {
    return {
      inNum: "",
      inButton: "",
      pageForm: {
        current: 1,
      },
      typeList: [],
    };
  },
  methods: {
    // 切换页码
    pageChange(v) {
      this.pageForm.current = v;

      this.$emit("tableClick", "pageChange", v);
    },
    // 游戏设置
    tableGame(v) {
      this.$emit("tableClick", "game", v);
    },
    // 管理者编辑
    tableManager(v) {
      this.$emit("tableClick", "manager", v);
    },
    // 删除
    tableDel(v) {
      this.$emit("tableClick", "del", v);
    },
    // 编辑客户信息
    tableWrite(v) {
      this.$emit("tableClick", "write", v);
    },
    buttonEnter(index, type) {
      this.inNum = index;
      this.inButton = type;
    },
    buttonLeave() {
      (this.inNum = ""), (this.inButton = "");
    },
  },
  mounted() {
    getDictDataByType("userManageRole").then((res) => {
      console.log(res);
      this.typeList = res.result;
    });
  },
};
</script>

<style lang="less" scoped>
.my-table {
  position: relative;
  padding-bottom: 20px;
}
.my-table .tableTitle,
.bodyItem {
  display: flex;
  justify-content: space-between;
  color: #000;
  padding-left: 30px;
  padding-right: 50px;
  height: 50px;
  line-height: 50px;
  & > div {
    flex: 3;
  }
  .action,
  .status {
    flex: 1;
  }
  .type {
    flex: 2;
  }
  .description {
    flex: 5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .blue {
    color: #307aea;
  }
  & > .status {
    text-align: center;
    margin-right: 10px;
    .status {
      padding: 6px;
      border-radius: 4px;
    }
    .status0 {
      border: 1px solid #307aea;
      color: #307aea;
      background: rgba(48, 122, 234, 0.05);
    }
    .status1 {
      background: rgba(34, 34, 34, 0.05);
      border: 1px solid rgba(34, 34, 34, 0.2);
      color: #999;
    }
  }
}
.my-table .tableTitle {
  background: #f4f4f4;
}
.bodyItem1 {
  background: #f5f8fe;
}
.action {
  display: flex;
  justify-content: center;
}
.action1 {
  justify-content: space-between;
  align-items: center;
  justify-content: center;

  .actionItem {
    width: 30px;
    height: 30px;
    background: #eaedf3;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    margin-right: 20px;
    .icon {
      width: 16px;
      height: 16px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
    }
    .icon1 {
      background: url("../assets/playManage.png") no-repeat 100% 100%;
    }
    .icon2 {
      background: url("../assets/admin.png") no-repeat 100% 100%;
    }
    .icon3 {
      background: url("../assets/edit.png") no-repeat 100% 100%;
    }
    .icon4 {
      background: url("../assets/del.png") no-repeat 100% 100%;
    }
  }
  & > div:last-child {
    margin-right: 0;
  }
}
.tipBox {
  position: absolute;
  height: 18px;
  line-height: 14px;
  display: flex;
  width: 100px;
  justify-content: center;
  top: -24px;
  left: 50%;
  transform: translateX(-50%);
  .tipText {
    height: 18px;
    background: #909090;
    font-size: 12px;
    padding: 2px;
    color: #f4f4f4;
  }
  .arrow {
    border: 4px solid transparent;
    border-top: 4px solid #909090;
    position: absolute;
    top: 18px;
  }
}
.pageChoose {
  position: relative;
  display: flex;
  justify-content: end;
  top: 18px;
}
.switch {
  opacity: 1;
}
</style>>

